<template>
    <jet-form-section @submitted="newUserInformation">
        <template #title>
            User Information
        </template>

        <template #description>
            Enter user's profile information and email address.
        </template>

        <template #form>

            <!-- Name -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="name" value="Name" />
                <jet-input id="name" type="text" class="mt-1 block w-full" v-model="form.name" autocomplete="name" />
                <jet-input-error :message="form.errors.name" class="mt-2" />
            </div>

            <!-- Email -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="email" value="Email" />
                <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" />
                <jet-input-error :message="form.errors.email" class="mt-2" />
            </div>

            <!-- Admin -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="admin" value="Admin" />
                <jet-select id="admin" class="mt-1 block w-full" v-model="form.admin">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                </jet-select>
                <jet-input-error :message="form.errors.admin" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <jet-button @click="createUser" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Create
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetFormSection from '@/Jetstream/FormSection.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetSelect from '@/Jetstream/Select.vue'
    import JetInputError from '@/Jetstream/InputError.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetActionMessage from '@/Jetstream/ActionMessage.vue'

    export default defineComponent({
        components: {
            JetActionMessage,
            JetButton,
            JetFormSection,
            JetInput,
            JetSelect,
            JetInputError,
            JetLabel,
        },

        data() {
            return {
                form: this.$inertia.form({
                    name: '',
                    email: '',
                    is_admin: false,
                }),
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('users.store')), {
                    errorBag: 'updateUserInformation',
                    preserveScroll: true,
                }
            },
        },
    })
</script>
